export const projects = [
  {
    title: "Huffman Coding",
    subtitle: "Java",
    description:
        "Implemented a program that allows the user to compress and decompress files through the use of bits and bit" +
        " manipulation.",
    image: "./huffman.gif",
    link: "https://github.com/b-rine/CS314/tree/main/assignment10/src",
  },
  {
    title: "Compound Interest Calculator",
    subtitle: "JSP, Tailwind CSS",
    description:
        "A simple compound interest calculator web application.",
    image: "./compIntCalc.gif",
    link: "https://github.com/b-rine/Compound-Interest-Calculator/tree/main",
  },
  {
    title: "Command Interpreter",
    subtitle: "C",
    description:
        "Completed a program that is capable of reading, evaluating, and printing a variety of data types, literals" +
        " and operations.",
    image: "./commandInterpreter.gif",
    link: "https://github.com/b-rine/CS429/tree/main/Command%20Interpreter/ci-lab-b-rine-main",
  },
  {
    title: "Books Management System",
    subtitle: "Java, JSP, MySQL",
    description:
        "A web application to keep track of the title, author, and price of various books.",
    image: "./bookManager.gif",
    link: "https://github.com/b-rine/book-manager",
  },
  {
    title: "Annual Average PM2.5 Concentration Predictor",
    subtitle: "R",
    description:
        "Created visualizations and utilized readily available models to predict air pollution.",
    image: "./pm2.5_prediction.gif",
    link: "https://nguyenbrian.me/pm2.5_prediction/",
  }
];

export const skills = [
  "Java",
  "C",
  "MySQL",
  "Python",
  "Jakarta Server Pages",
  "R",
  "HTML",
  "CSS",
  "JavaScript",
  "ARM Assembly",
  "Bash",
  "Spring",
];


// WEBPACK FOOTER //
// ./src/data.js